import propertiesAPI from '@/api/properties'

export const getProperties = ({ commit }) => {
  return new Promise((resolve, reject) => {
    propertiesAPI.getProperties(response => {
      resolve(response.data.data.properties)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/properties/actions.js